import { render, staticRenderFns } from "./IconWithTooltip.vue?vue&type=template&id=68b81d0a"
import script from "./IconWithTooltip.vue?vue&type=script&lang=ts"
export * from "./IconWithTooltip.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports